<template>
  <b-container>
    <b-row align-h="center">
      <b-col cols="8">
        <b-card>
          <b-form v-on:submit.prevent>
            <b-form-group label="Warehouse" label-for="warehouse">
              <v-select
                id="warehouse"
                v-model="form.selectedWarehouse"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="text"
                :options="form.optionsWarehouse"
                placeholder="Select 1 Warehouse"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!form.selectedWarehouse"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <!-- Selected: <strong>{{ form.selectedWarehouse }}</strong> -->
            </b-form-group>
            <b-form-group label="Product" label-for="product">
              <v-select
                id="product"
                v-model="form.selectedProduct"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="text"
                :options="form.optionsProduct"
                placeholder="Select 1 Product"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!form.selectedProduct"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <!-- Selected: <strong>{{ form.selectedProduct }}</strong> -->
            </b-form-group>
            <b-form-group label="Qty" label-for="qty" class="w-50">
              <b-form-input
                id="qty"
                placeholder="Qty"
                v-model="form.qty"
                required
              />
            </b-form-group>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mt-1"
              @click="validation()"
            >
              Submit
            </b-button>
          </b-form>
        </b-card>
      </b-col>
      <b-col cols="4" v-if="form.selectedProduct !== null">
        <b-card>
          <b-form v-on:submit.prevent>
            <b-row>
              <b-col cols="12">
                <label for="details" class="text-primary font-weight-bold"
                  >Item</label
                >
              </b-col>
              <b-col cols="12">
                <label class="mb-1">Image</label>
                <b-img
                  id="image"
                  :src="product.url"
                  fluid
                  alt="Product Image"
                  v-b-modal.modal-lg
                />
                <b-modal
                  id="modal-lg"
                  ok-only
                  ok-title="close"
                  centered
                  size="lg"
                  title="Large Modal"
                  class="text-center"
                >
                  <b-img
                    id="image"
                    :src="product.url"
                    width="1000px"
                    fluid
                    alt="product image"
                  />
                </b-modal>
              </b-col>
              <b-col cols="12">
                <b-row>
                  <b-col cols="4"> Name </b-col>
                  <b-col cols="8" class="text-right">
                    {{ product.name }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col cols="4"> Code </b-col>
                  <b-col cols="8" class="text-right">
                    {{ product.code }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col cols="4"> Category </b-col>
                  <b-col cols="8" class="text-right">
                    {{ product.category_name }}
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col cols="4"> Unit </b-col>
                  <b-col cols="8" class="text-right">
                    {{ product.unit_name }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BImg,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { $themeConfig } from "@themeConfig";

export default {
  components: {
    ToastificationContent,
    vSelect,
    BImg,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        selectedWarehouse: null,
        optionsWarehouse: [],
        selectedProduct: null,
        optionsProduct: [],
        qty: "",
      },
      product: {
        name: "",
        url: "",
        code: "",
        category_name: "",
        unit_name: "",
      },
      warehouse_id: null,
      errors: "",
      errMessage: "",
    };
  },
  setup() {
    // App Name
    const { baseUrl, apiUrl } = $themeConfig.app;
    return {
      baseUrl,
      apiUrl,
    };
  },
  watch: {
    "form.selectedWarehouse": function (data) {
      this.getProduct(data.value);
    },
    "form.selectedProduct": function (data) {
      this.trigger(data.product_id);
    },
  },
  created() {
    this.getWarehouse();
  },
  methods: {
    getWarehouse() {
      this.$http.get("warehouses").then((response) => {
        // console.log(response.data.data)
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsWarehouse.push($data);
        }
        // console.log(this.form.optionsWarehouse)
      });
    },
    getProduct($warehouse_id) {
      this.$http
        .get("warehouse/" + $warehouse_id + "/items")
        .then((response) => {
          // console.log(response.data.data)
          this.form.selectedProduct = null;
          this.form.optionsProduct.splice(0);

          var datas = response.data.data;
          var i;
          for (i = 0; i < datas.length; i++) {
            var $data = {
              value: datas[i].id,
              product_id: datas[i].product_id,
              text: datas[i].product_name,
            };
            // console.log($data)
            this.form.optionsProduct.push($data);
          }
          // console.log(this.form.optionsProduct)
        });
    },
    trigger($id) {
      this.$http.get("product/" + $id).then((response) => {
        // console.log(response.data.data)
        this.product.name = response.data.data.name;
        const { baseUrl } = $themeConfig.app;
        this.product.url = baseUrl;
        this.product.url += "storage/product/";
        this.product.url += response.data.data.image;
        this.product.code = response.data.data.code;
        this.product.category_name = response.data.data.category_name;
        this.product.unit_name = response.data.data.unit_name;
      });
    },
    validation() {
      if (this.form.selectedWarehouse === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Warehouse field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedProduct === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Product field is required",
            variant: "warning",
          },
        });
      } else if (this.form.qty === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Code field is required",
            variant: "warning",
          },
        });
      } else {
        this.addReplenishment();
      }
    },
    addReplenishment() {
      if (this.form.selectedProduct !== null) {
        var $item_id = this.form.selectedProduct.value;
      }
      this.$http
        .post("warehouse/replenishment/add", {
          item_id: $item_id,
          qty: this.form.qty,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success add Replenishment",
              variant: "success",
            },
          });
          location.href = "/warehouse/replenishment";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>